import React from 'react';
import { connect } from 'react-redux';
import { setDialogs } from '../../actions';
import { has } from 'lodash';
import { query } from '../../lib/util/common';
import { CardTitle, SignInCarousel, SignInGuideDialog, ActionFalseDialog, ActionSuccessDialog, Integral } from '../../components';
import { post } from '../../lib/kbApp/kbJsBridgePromise';
import { getHost, ACCOUNT, TASK_EVOLVE_TYPE, BLACK_USER_DIALOG } from '../../const';
import { getWelfareCenterParams, loginAction, signInAction, doPreProcess, getSignTaskAction, setWelfareAnimation } from '../../rootStore';
import { showTip } from '../../lib/util/domUtil.js';
import { getSchemeHeader } from '../../lib/util/utils';
import './index.scss';
import '../../common/css/animate-newuser.scss';
import '../../common/css/animate-loop.scss';

class SignInMoney extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      receiveAmount: 0,
      withdrawLock: false,
    };
    this.Log = this.props.Log;
  }

  componentDidMount() {
    this.dealSiginAction();  // 自动签到、签到引导

    this.Log && this.Log.sendExposure({
      element_type: 'cashsign',
      element_name: 'module',
    });
    this.Log && this.Log.sendExposure({
      element_type: 'total_property',
    });

    const { testBucket } = this.props;

    if (testBucket >= 0) {
      this.Log && this.Log.sendExposure({
        element_type: 'cashsign',
        element_name: 'property',
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLogin !== this.props.isLogin) {
      this.dealSiginAction();
    }
  }

  // 签到模块展示处理，自动签到、签到引导
  dealSiginAction = () => {
    const { completed = 0, hasSigned = false, isContinueTask, continueTaskDays = 0, taskEvolve } = this.props.signTask;
    if ([
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_GUID,
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_QBID,
	  ].includes(taskEvolve)) {
	    if (has(window, 'browser.app.showAlertDialog')) {
	      window.browser.app.showAlertDialog(() => {}, BLACK_USER_DIALOG);
	    }
	    return;
	  }
    // 确认当前是第几次签到，连续任务和非连续任务取不同字段
    const taskDays = isContinueTask ? continueTaskDays : completed;

    const isNotMatchDeviceOrBlack = [ACCOUNT.STATUS.NOT_MATCH_DEVICE, ACCOUNT.STATUS.TINAYU_BLACK]
      .includes(this.props.credit);
    if (!hasSigned && !isNotMatchDeviceOrBlack) {
      if (taskDays === 0 && this.props.dialogs.length === 0) {  // 第一次未签到且无其他弹窗情况下出签到引导弹窗
        this.Log && this.Log.sendExposure({
          element_type: 'cashsign',
          element_name: this.props.isLogin ? 'cashsign_popup_login' : 'cashsign_popup_unlogin',
        });

        this.signInGuide();
      } else if (this.props.dialogs.length === 0) {  // 无其他弹窗情况下自动签到
        signInAction('cash');  // 未签到默认签到
      }
    } else {
      // 没有签到弹窗就播放动画
      setWelfareAnimation();
    }
  }

  signInGuide = () => {
    const len = this.props.dialogs.length;
    this.props.dispatch(setDialogs(this.props.dialogs.concat([
      <SignInGuideDialog key={len} type="cash" Log={this.Log}></SignInGuideDialog>,
    ])));
  }

  signInClick = (hasSigned) => {
    const { signTask: { taskEvolve } } = this.props;
    if ([
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_GUID,
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_QBID,
	  ].includes(taskEvolve)) {
	    if (has(window, 'browser.app.showAlertDialog')) {
	      window.browser.app.showAlertDialog(() => {}, BLACK_USER_DIALOG);
	    }
	    return;
	  }
    if (this.props.isLogin) {  // 已登录
      signInAction('cash');
    } else {
      loginAction();
    }
  }

  withdrawClick = () => {
    if (this.props.isLogin) {  // 已登录
      this.withdraw();
    } else {
      loginAction();
    }
  }

  // 提现
  withdraw = () => {
    const { extraInfo = {}, isWelfareNeedReceive = false, taskId } = this.props.signTask;
    const receiveInfo = extraInfo.receiveInfo ? JSON.parse(extraInfo.receiveInfo) : {};
    const { canReceive, min = 0, balance = 0 } = receiveInfo;

    if (isWelfareNeedReceive) {  // 可直接提现
      if (canReceive === true) {
        const param = Object.assign(getWelfareCenterParams(), {
          taskId,
          refer: query('refer'),
        });
        param.accountType = param.type || '';

        if (this.state.withdrawLock) {
          return;
        }
        this.state.withdrawLock = true;
        post(`${getHost()}/newtickets/api/signInWithdraw`, param).then((res) => {
          this.state.withdrawLock = false;
          if (res.code === 0) {
            getSignTaskAction(); // 更新页面状态

            const len = this.props.dialogs.length;
            this.props.dispatch(setDialogs(this.props.dialogs.concat([
              <ActionSuccessDialog key={len} from="signInMoney" title={`已成功提现${balance / 100}元至微信`} subTitle="24小时内即可到账，请放心"></ActionSuccessDialog>,
            ])));

            this.Log && this.Log.sendExposure({
              element_type: 'cashsign',
              element_name: 'cashsign_popup_withdraw_success',
            });
          } else {
            const len = this.props.dialogs.length;
            this.props.dispatch(setDialogs(this.props.dialogs.concat([
              <ActionFalseDialog key={len} title="很抱歉，提现失败" subTitle="你的账户存在异常，无法提现" history={this.props.history}></ActionFalseDialog>,
            ])));

            this.Log && this.Log.sendExposure({
              element_type: 'cashsign',
              element_name: 'cashsign_popup_withdraw_fail',
            });
          }
        });
      } else {
        showTip(`${min / 100}元就可提现啦`, 3000);
      }
    } else {
      this.toOldWithdraw();
    }
  }

  // 老版提现
  toOldWithdraw = () => {
    const url = `${getHost()}/welfare/withdraw?refer=welfare_new`;
    window.location.href = `${getSchemeHeader()}://webview?url=${encodeURIComponent(url)}&innerfrom=welfare_new`;
  }

  // 收益记录
  toIncome = (tab, position) => {
    if (this.props.isLogin) {  // 已登录
      if (position == 'property') {
        this.Log && this.Log.sendClick({
          element_type: 'cashsign',
          element_name: 'property',
        });
      }
      this.Log && this.Log.sendClick({
        element_type: 'total_property',
        element_name: `total_${tab}`,
      });
      this.props.history.push({
        pathname: '/incomeRecord', state: {
          tab,
        },
      });
    } else {   // 未登录
      loginAction();
    }
  }

  stepRender = (step, index, taskDays, curStep) => {
    const welfareInfo = step.welfareInfo || {};
    const { value = 0, welfareType } = welfareInfo;

    return (
      <div className="item" key={index}>
        <div className={`redpack ${index < taskDays ? 'hasSign' : ''}`}>
          <div className="money">
            <span className="num">{welfareType === 0 && value === 0 ? '?' : value / 100}</span>
            <span className="text">元</span>
          </div>
        </div>
        <div className="day">
          {this.getDayRender(index, curStep)}
        </div>
      </div>
    );
  }

  getDayRender = (index, curStep) => {
    const { hasSigned = false } = this.props.signTask;

    if (index < curStep) {
      return (
        <React.Fragment>
          已领取
        </React.Fragment>
      );
    } if (index === curStep) {
      if (hasSigned) {
        return (
          <React.Fragment>
            已领取
          </React.Fragment>
        );
      }
      return <span className="highlight">今天</span>;
    }
    return `${index + 1}天`;
  }

  // 资产外漏实验
  // propertyExperRender = () => {
  //   const { integral = 0, amount = 0 } = this.props.myIntegral;
  //   const { testBucket } = this.props;

  //   if (testBucket >= 0) {
  //     return (
  // 			<React.Fragment>
  // 				{this.props.isLogin
  // 				  ? <div className="propertyWrap">
  // 						<div className="coinInfo">
  // 							<div className="coinItem"
  // 								onClick={() => doPreProcess(this.toIncome)('cash', 'property')}
  // 							>
  // 								<div className="moneyInfo"><span className="num">{amount.toFixed(2)}</span>元</div>
  // 								<div className="moneyTip">满3元可提现<span className="arrow"></span></div>
  // 							</div>
  // 							<div className="coinItem" onClick={() => doPreProcess(this.toIncome)('coin', 'property')}>
  // 								<div className="moneyInfo"><span className="num">{integral}</span>金币</div>
  // 								<div className="moneyTip">兑换现金<span className="arrow"></span></div>
  // 							</div>
  // 						</div>
  // 					</div>
  // 				  :						<div className="login" onClick={() => loginAction()}>
  // 						<div className="weixin"></div>
  // 						<div className="qq"></div>
  // 						<div className="desc">
  // 							<div className="loginNow">立即登录领金币</div>
  // 							<div className="loginTip">用微信/QQ账号快速登录</div>
  // 						</div>
  // 					</div>
  // 				}
  // 			</React.Fragment>
  //     );
  //   }
  //   return (
  // 			<React.Fragment>
  // 				<div className="spark spark1"></div>
  // 				<div className="spark spark2"></div>
  // 				<div className="coinDim1"></div>
  // 				<div className="coinDim2"></div>
  // 				<div className="incomeRecord" onClick={() => doPreProcess(this.toIncome)('cash')} log-click-elname="income" log-click-eltype="cashsign">收益记录</div>
  // 			</React.Fragment>
  //   );
  // }

  render() {
    const { isShowTaotie, isShowTaotieSwing } = this.props;
    const {
      stepWelfare = [],
      completed = 0,
      hasSigned = false,
      isWelfareNeedReceive = false,
      isContinueTask, continueTaskDays = 0,
      extraInfo = {},
    } = this.props.signTask;

    let curStep = 0;
    const taskDays = isContinueTask ? continueTaskDays : completed;
    let btnText = '';
    if (hasSigned) {
      curStep = taskDays - 1;  // 找出今天是第几步

      if (taskDays === 7) {
        btnText = '签到成功';
      } else {
        const welfare = (stepWelfare[taskDays] && stepWelfare[taskDays].welfareInfo) || {};  // 找到明天的签到福利
        if (welfare.welfareType === 0 && welfare.value === 0) {  // 随机红包奖励
          btnText = '明天签到可领随机红包';
        } else {
          btnText = `明天签到可领${welfare.value / 100 || 0}元`;
        }
      }
    } else {
      curStep = taskDays;  // 找出今天是第几步
      btnText = '立即签到';
    }

    // 获取提现金额
    let receiveInfo = extraInfo.receiveInfo || '{}';
    receiveInfo = JSON.parse(receiveInfo);
    let receiveAmount = 0;
    if (isWelfareNeedReceive) {
      receiveAmount = receiveInfo.balance ? receiveInfo.balance / 100 : 0;  // 如果可以直接领取现金，展示签到现金金额
    }

    return (
      <div className="signinMoney">
        {/* {this.propertyExperRender()} */}
        {/* <Integral history={this.props.history}></Integral> */}
        <div className="coinWrap">
          <div className="spartAnimateWrap spark1">
            <div className="spartAnimate"></div>
          </div>
          <div className="spartAnimateWrap spark2">
            <div className="spartAnimate"></div>
          </div>
          <div className="titleWrap">
            <div className="animatWrap">
              <div className={`taotie-anim ${isShowTaotie ? 'taotie-in' : ''}`}>
                <div className={`taotie-swing ${isShowTaotieSwing ? 'show' : ''}`}></div>
              </div>
            </div>

            <CardTitle title="连续7天签到领现金" subTitle="断签将重新开始"></CardTitle>
          </div>
          <div className="coinAnimateWrap">
            {isShowTaotie
              ? <div className="coinAnimate"></div>
              : <div className="stay-coin-newuser"></div>
            }
          </div>
        </div>
        <div className="signinBoard">
          <div className="cash">
            {isWelfareNeedReceive
              ? <React.Fragment>
                金额:
								<span className="num">
                  {receiveAmount.toFixed(2)}
                </span>元
								<span className="withdraw" onClick={() => doPreProcess(this.withdrawClick)()} log-click-elname="withdraw" log-click-eltype="cashsign">提现</span>
              </React.Fragment>
              : <div className="myPrize" onClick={() => doPreProcess(this.toIncome)('cash')}>
                签到记录<span className="icon"></span>
              </div>
            }
          </div>
          <div className="redpackWrap">
            <div className="line">
              {stepWelfare.map((step, index) => (
                index < 4 && this.stepRender(step, index, taskDays, curStep)
              ))}
            </div>
            <div className="line">
              {stepWelfare.map((step, index) => (
                index >= 4 && this.stepRender(step, index, taskDays, curStep)
              ))}
              <div className="item">
                <div className="redpack"></div>
                <div className="day">第7天</div>
              </div>
            </div>
          </div>
          {hasSigned
            ? <div className="signInBtn disable">
              {btnText}
            </div>
            : <div className="signInBtn" onClick={() => doPreProcess(this.signInClick)()} log-click-elname="sign" log-click-eltype="cashsign">
              {btnText}
            </div>
          }
          <SignInCarousel></SignInCarousel>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { dialogs, myIntegral, signTask, isLogin, preProcess, testBucket, isShowTaotieSwing, isShowTaotie } = state;
  return {
    dialogs,
    myIntegral,
    signTask,
    isLogin,
    preProcess,
    testBucket,
    isShowTaotieSwing,
    isShowTaotie,
  };
};

export default connect(mapStateToProps)(SignInMoney);
